(function ($) {
	/**
	 * Open sidebar navigation.
	 */
	$("#sidebar-navigation-open").click((e) => {
		$(e.currentTarget).parents(".sidebar-navigation").addClass("active");
		$("body").addClass("sidebar-navigation-active");
	});

	/**
	 * Close sidebar navigation.
	 */
	$("#sidebar-navigation-close").click((e) => {
		$(e.currentTarget).parents(".sidebar-navigation").removeClass("active");
		$("body").removeClass("sidebar-navigation-active");
	});

	/**
	 * Close the sidebar navigation when click on the overlay
	 */
	$(".sidebar-navigation .overlay").click((e) => {
		$(e.currentTarget).parents(".sidebar-navigation").removeClass("active");
		$("body").removeClass("sidebar-navigation-active");
	});

	/**
	 * Close sidebar navigation with the ESC key.
	 */
	$(document).keyup((e) => {
		if (e.key === "Escape") {
			$(".sidebar-navigation").removeClass("active");
			$("body").removeClass("sidebar-navigation-active");
		}
	});

	/**
	 * Toogle form labels.
	 */
	$("input[type=text]").on("focusin", (e) => {
		$(e.currentTarget).parent().parent().find("label").addClass("active");
	});

	$("input[type=text]").on("focusout", (e) => {
		if (!e.value) {
			$(e.currentTarget).siblings("label").removeClass("active");
		}
	});

	/**
	 * Gravity Forms: toggle class for fields with value
	 */
	$(".gform_wrapper input[type=text], .gform_wrapper textarea").focusout(
		function (e) {
			var value = $(this).val();
			if (!value) {
				$(this).removeClass("gf_active");
			} else {
				$(this).addClass("gf_active");
			}
		}
	);
	$(
		".gform_wrapper input[type=checkbox], .gform_wrapper input[type=radio]"
	).focusout(function (e) {
		var checked = $(this).is(":checked");
		if (!checked) {
			$(this).removeClass("gf_active");
		} else {
			$(this).addClass("gf_active");
		}
	});
	$(".gform_wrapper select").change(function (e) {
		var selected = this.value;
		if (!selected) {
			$(this).removeClass("gf_active");
		} else {
			$(this).addClass("gf_active");
		}
	});

	/**
	 * Add a zoom icon to linked BB images in the content.
	 */
	$(".fl-module-photo .fl-photo a").each(function (i, el) {
		if (/\.(jpg|jpeg|png|gif)$/.test(el.href)) {
			$(this)
				.css({ display: "block", position: "relative" })
				.children(".fl-photo-img")
				.after('<div class="image-zoom-icon"></div>');
		}
	});

	/**
	 * Copy all e-mail addresses from the content and display
	 * it as a comma seperated list.
	 *
	 * Note: Helper function for Esben to copy emails into an email list.
	 */
	$(".js-hent-epostadresser .fl-button").on("click", function (event) {
		event.preventDefault();

		const content = $(".fl-builder-content").html();
		const emailsArray = content.match(
			/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi
		);

		if (!emailsArray) {
			window.alert("Fant ingen e-postadresser i innholdet!");
			return;
		}

		// Remove duplicates
		const emails = [...new Set(emailsArray)].join(", ");

		$(this).after(
			`<div style="margin-top:20px"><h4>E-postadresser:</h4><textarea rows=25 style="width:100%">${emails}</textarea></div>`
		);
	});
})(jQuery);
